export function cloneWithInlineStyles(node) {
  const clone = node.cloneNode(false);
  clone.removeAttribute("class");
  clone.removeAttribute("id");
  clone.removeAttribute("name");
  clone.removeAttribute("for");
  clone.removeAttribute("style");
  if (clone instanceof HTMLElement || clone instanceof SVGElement) {
    Object.keys(clone.dataset).forEach((key) => {
      clone.dataset[key] = "";
    });
  }
  const computedStyle = getComputedStyle(node);
  for (let i = 0; i < computedStyle.length; i++) {
    const propName = computedStyle[i];
    if (clone instanceof HTMLElement || clone instanceof SVGElement) {
      clone.style[propName] = computedStyle.getPropertyValue(propName);
    }
  }
  Array.from(node.childNodes).forEach((child) => {
    if (child.nodeType === Node.ELEMENT_NODE) {
      clone.appendChild(cloneWithInlineStyles(child));
    } else if (child.nodeType === Node.TEXT_NODE) {
      clone.appendChild(child.cloneNode(true));
    }
  });
  return clone;
}
export function cloneElementWithStyles(element, isRoot) {
  const clonedElement = cloneWithInlineStyles(element);
  if (isRoot && (clonedElement instanceof HTMLElement || clonedElement instanceof SVGElement)) {
    clonedElement.style.opacity = "1";
  }
  const container = document.createElement("div");
  container.appendChild(clonedElement);
  return container.innerHTML;
}
